// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2ot9c","checkboxCol":"Table_checkboxCol__b_EPs","emailCol":"Table_emailCol__15-pl","actionCol":"Table_actionCol__2shN6"};